<template>
    <div id="screen" :class="[cWrapper[0], cWrapper[1], cWrapper[2]]">
        <div class="title">{{title}}
            <span>{{index}}{{total}}</span>
        </div>
        <!-- <ul class="content-wrapper" v-for="content in  contentData" > -->
        <ul class="content-wrapper" v-for="(content, index) in  contentData">
            <li class="upper">
                <!-- <span v-for="(item, index) in content[0]" v-text="item"></span> -->
                <div v-for="(item, index) in content[0]" v-text="item"></div>
            </li>
            <li class="bottom">
                <!-- <span v-for="(item, index) in content[1]">{{item}}</span> -->
                <div v-for="(item, index) in content[1]">{{item}}</div>
            </li>
        </ul>
        <div class="memo">{{memoData}}</div>
    </div>
</template>

<script>
export default { 
    name: 'Screen',
    data() {
        return {
            showedData: []
        }
    },
    computed:{
        title(){
            return this.showedData[0][0][0]
        },
        showIndex(){
            return this.showIndex[0][0][1]
        },
        //定义页面的特殊显示类
        cWrapper(){
            return this.showedData[0][0][1]        
        },

        index(){
            if(this.showedData[0][1][0]==1 && this.showedData[0][1][1]==1){
                return ''
            }
            return this.showedData[0][1][0]
            
        },
        total(){
            if(this.showedData[0][1][1]>1){
                return '/' + this.showedData[0][1][1]
            }
        },
        contentData(){
            return this.showedData.slice(1,7)
        },
        memoData: {
            get() {
                let memoData = this.$store.state.currentStatus.memoData

                if(memoData.input){
                    return this.memoData = memoData.input

                }else if(memoData.warning.length){

                    return this.memoData = memoData.warning[0]
                    
                }else if(memoData.caution.length){

                    return this.memoData = memoData.caution[0]
                }
            },
            set() {
            }
        }
    },
    watch: {
        '$store.state.screen':{
            handler (newV, oldV) {
                this.showedData = newV.content
            },
            deep:true,
            immediate: true,
        }
    }

}
</script>

<style scoped>
    #screen{
        background-color: var(--color-screen-bgc);
        /* 原始设计图的数据↓ */
        /* width: 6.8rem;
        height: 5.6rem;
        padding: 0 0.1rem; */
        width: 7.0rem;
        height: 5.6rem;
        padding:  0 0.3rem;
        border-radius: .16rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        text-align: left;
        white-space: nowrap;   
        overflow: hidden;
    }

    .title{
        /* 原始设计图高度是39px */
        /* 现在高度是33px */
        /* height: 33px; */
        width: 100%;
        height: .44rem;
        /* background-color: aqua; */
        font-size: .36rem;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        position: relative;
    }

    .title span{
        position: absolute;
        right: 0;
    }

    .content-wrapper{
        width: 6.8rem;
        height: .74rem;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;    
    }

    .content-wrapper > .upper{
        width: 100%;
        height: var(--font-size-content-up);
        font-size: var(--font-size-content-up);
        line-height: var(--font-size-content-up);
        /* height: .24rem;
        font-size: .24rem;
        line-height: .24rem; */
        display: flex;
        justify-content: space-between;
        overflow: hidden;
    }

    .content-wrapper > .bottom{
        width: 100%;
        height: var(--font-size-content-bottom);
        font-size: var(--font-size-content-bottom);
        line-height: var(--font-size-content-bottom);
        /* height: .32rem;
        font-size: .32rem;
        line-height: .32rem; */
        display: flex;
        justify-content: space-between; 
        overflow: hidden;
    }

    .memo{
        width: 6.8rem;
        height: .64rem;
        /* font-size: .32rem; */
        font-size: var(--font-size-content-bottom);
        display: flex;
        align-items: flex-end;
        overflow: hidden;
    }

    .eqhal .upper{
        height: 50%;
        font-size: var(--font-size-content-eqhal);
        line-height: var(--font-size-content-eqhal);
    }

    .eqhal .bottom{
        height: 50%;
        font-size: var(--font-size-content-eqhal);
        line-height: var(--font-size-content-eqhal);
    }

    .showIndex>.title::after{
        content: '1/1';
        display: inline-block;
        position: absolute;
        right: 0;
    }
</style>